import React from 'react';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;

const LoadingModal = ({ open }) => (
  <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={open}
  >
    <Container>
      <CircularProgress size={100} color="secondary" />
    </Container>
  </Modal>
);

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/components/common/LoadingModal.js